import type { ReceiptTemplate } from '../schema';

export const uHaulTemplate: ReceiptTemplate = {
  id: 'u-haul',
  name: 'U-Haul Receipt',
  brand: 'U-HAUL',
  description: 'U-Haul truck rental receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'uh-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'U-HAUL',
        businessNameFontSize: 22,
        addressLines: ['1200 DARK AVENUE', 'MONSTERVILLE, CA 94608', '(510) 555-0127'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uh-rental',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'contract', label: 'Contract #:', value: '847291034' },
          { id: 'customer', label: 'Customer:', value: 'JOHN DOE' },
        ],
        column2: [
          { id: 'pickup', label: 'Pick-Up:', value: '01/02/2026' },
          { id: 'return', label: 'Return:', value: '01/03/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'uh-equipment',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'EQUIPMENT:\n15\' Moving Truck\nDolly\nFurniture Pads (12)', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'uh-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'truck', label: 'TRUCK RENTAL', value: '39.95', isBold: false, isLarge: false },
          { id: 'mileage', label: 'MILEAGE (50 MI)', value: '49.50', isBold: false, isLarge: false },
          { id: 'dolly', label: 'DOLLY', value: '10.00', isBold: false, isLarge: false },
          { id: 'pads', label: 'FURNITURE PADS', value: '12.00', isBold: false, isLarge: false },
          { id: 'insurance', label: 'SAFEMOVE', value: '14.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '10.35', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '135.80', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uh-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'uh-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'THANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

